import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown-label" }
const _hoisted_2 = { class: "dropdown-menu" }
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = { class: "menu-item team-item" }
const _hoisted_5 = { class: "dropdown-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!

  return (_openBlock(), _createBlock(_component_VDropdown, {
    theme: "info-dropdown",
    placement: "bottom-start",
    triggers: ['click'],
    popperClass: _ctx.rootMenuClass
  }, {
    popper: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
          return (_openBlock(), _createBlock(_component_VDropdown, {
            key: project.id,
            placement: "right-start",
            triggers: ['click'],
            popperClass: _ctx.secondMenuClass,
            skidding: -16
          }, {
            popper: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["dropdown-menu rootMenuClass", _ctx.rootMenuClass])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.teams, (team) => {
                  return (_openBlock(), _createBlock(_component_VDropdown, {
                    key: team.id,
                    placement: "right-start",
                    popperClass: _ctx.thirdMenuClass,
                    triggers: ['click'],
                    skidding: -16
                  }, {
                    popper: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "sprint", {
                          sprints: team.sprints
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "team", { team: team })
                      ])
                    ]),
                    _: 2
                  }, 1032, ["popperClass"]))
                }), 128))
              ], 2)
            ]),
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_3, [
                _renderSlot(_ctx.$slots, "project", { project: project })
              ])
            ]),
            _: 2
          }, 1032, ["popperClass"]))
        }), 128)),
        (!_ctx.projects.length)
          ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
              key: 0,
              size: "large",
              weight: "400",
              color: "monochrome-07"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" No Projects found ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", _hoisted_1, [
        _renderSlot(_ctx.$slots, "label")
      ])
    ]),
    _: 3
  }, 8, ["popperClass"]))
}